export function formatTimestamp(isoTimestamp) {
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    const date = new Date(isoTimestamp);
    const now = new Date();

    const isToday = date.toDateString() === now.toDateString();
    const isYesterday = date.toDateString() === new Date(now.setDate(now.getDate() - 1)).toDateString();

    const timeString = date.toLocaleTimeString('en-US', options);
    
    if (isToday) {
        return `Today | ${timeString}`;
    } else if (isYesterday) {
        return `Yesterday | ${timeString}`;
    } else {
        const monthDayString = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        return `${monthDayString} | ${timeString}`;
    }
}